import {useMemo} from 'react'

const createPositionReference = (refs, getBoundingClientRectFn) => event => {
	const {currentTarget} = event

	refs.setPositionReference({
		getBoundingClientRect() {
			return getBoundingClientRectFn(event, currentTarget)
		},
		contextElement: currentTarget.parentElement,
	})
}

const positionStrategies = {
	x: (event, currentTarget) => {
		const {clientX} = event
		const {y, top, bottom, height} = currentTarget.getBoundingClientRect()

		return {
			width: 0,
			height: 0,
			x: clientX,
			left: clientX,
			right: clientX,
			y: y + height,
			top: top + height,
			bottom: bottom + height,
		}
	},

	y: (event, currentTarget) => {
		const {clientY} = event
		const {x, left, right, width} = currentTarget.getBoundingClientRect()

		return {
			width: 0,
			height: 0,
			x: x + width,
			left: left + width,
			right: right + width,
			y: clientY,
			top: clientY,
			bottom: clientY,
		}
	},

	xy: (event, _) => {
		const {clientX, clientY} = event
		return {
			width: 0,
			height: 0,
			x: clientX,
			y: clientY,
			left: clientX,
			right: clientX,
			top: clientY,
			bottom: clientY,
		}
	},
}

export const useOpenAtCursorPosition = (context, {enabled, axis}) => {
	const {refs, open} = context

	const referenceProps = useMemo(() => {
		if (!enabled || open) return {}

		const positionStrategy = positionStrategies[axis]

		return {
			onClick: createPositionReference(refs, positionStrategy),
		}
	}, [refs, enabled, open])

	return useMemo(
		() => ({
			reference: referenceProps,
		}),
		[referenceProps],
	)
}
